export enum freshnessPeriod {
  "120_days",
  "1_year",
}
export interface ConsensusTemplateDataResponse {
  data: Array<ConsensusTemplateTableData>;
  status: string;
  consensus_status: string;
  data_total: Array<ConsensusTemplateTableData>;
  note_response: {
    data: Array<any>;
    status: string;
    total_length: number;
  };
}

export interface ConsensusTemplateTableData {
  forecast_excluded: number;
  forecast_used: number;
  n_forecast_blank: number;
  n_forecast_inferred: number;
  name: string;
  notes: number;
  tabsn?: string;
  total: number;
  selected?: boolean;
}
